import { BagIcon, CupCoffeeIcon } from "@lhd/assets";
import { Styles } from "./styled";
import Status from "../../components/Status";
import { LogItem, LogTimeByDateResponse } from "@lhd/types";
import {
  formatSecondsToJp,
  getTrackingStatusLabel,
  getTrackingStatusChipColors,
} from "@lhd/features/TrackingTime/until";
import {
  calculateTotalBreakMs,
  calculateTotalWorkingMs,
  getTimedLogs,
  sortLogsByLoggedAt,
} from "@lhd/features/TrackingTime/HomeTracking/until";
import { LOG_TYPE } from "@lhd/features/TrackingTime/HomeTracking/contants";
import { useMemo } from "react";

interface IProps {
  className?: string;
  data?: LogTimeByDateResponse;
  liveLogtimes?: LogItem[];
  serverNowMs?: number;
  isLiveSessionOpen?: boolean;
  closedAtMs?: number;
}

const toWholeSecondMs = (ms: number): number => Math.floor(ms / 1000) * 1000;

const toCompletedMinuteSeconds = (ms: number): number =>
  Math.floor(Math.max(0, ms) / 60_000) * 60;

const Summary = (props: IProps) => {
  const {
    className,
    data,
    liveLogtimes,
    serverNowMs,
    isLiveSessionOpen,
    closedAtMs,
  } = props;

  const { workingSeconds, breakSeconds } = useMemo(() => {
    const sourceLogs =
      isLiveSessionOpen && liveLogtimes != null && liveLogtimes.length > 0
        ? liveLogtimes
        : data?.logtimes ?? [];

    const logtimes = getTimedLogs(sourceLogs).filter(
      (log) => log.log_type !== LOG_TYPE.NOTE,
    );

    const lastLog = sortLogsByLoggedAt(logtimes).at(-1);
    const isOnBreak = lastLog?.log_type === LOG_TYPE.BREAK_START;

    let workingNowMs: number | undefined;
    let breakNowMs: number | undefined;

    if (isLiveSessionOpen) {
      const liveNow = toWholeSecondMs(serverNowMs ?? Date.now());
      if (isOnBreak) {
        breakNowMs = liveNow;
      } else {
        workingNowMs = liveNow;
      }
    } else if (closedAtMs != null) {
      workingNowMs = closedAtMs;
    }

    return {
      workingSeconds: toCompletedMinuteSeconds(
        calculateTotalWorkingMs(logtimes, workingNowMs),
      ),
      breakSeconds: toCompletedMinuteSeconds(
        calculateTotalBreakMs(logtimes, breakNowMs),
      ),
    };
  }, [
    closedAtMs,
    data?.logtimes,
    isLiveSessionOpen,
    liveLogtimes,
    serverNowMs,
  ]);

  const workingHoursText = formatSecondsToJp(workingSeconds);
  const breakHoursText = formatSecondsToJp(breakSeconds);
  const statusLabel = getTrackingStatusLabel(data?.logtime_status);
  const chipColors = getTrackingStatusChipColors(statusLabel);

  return (
    <Styles className={className || ""}>
      <div className="title mb-2">
        <span>本日のサマリー</span>
      </div>
      <div className="container-summary mb-1">
        <div className="summary-item">
          <div className="icon time_start">
            <BagIcon />
          </div>
          <div>
            <div className="title">勤務時間</div>
            <div className="text-info">{workingHoursText}</div>
          </div>
        </div>
        <div className="summary-item">
          <div className="icon time_break">
            <CupCoffeeIcon />
          </div>
          <div>
            <div className="title">休憩時間</div>
            <div className="text-info">{breakHoursText}</div>
          </div>
        </div>
      </div>
      <div className="container-status">
        <span>状態</span>
        <Status label={statusLabel} chipColors={chipColors} />{" "}
      </div>
    </Styles>
  );
};
export default Summary;
